<template>
    <fieldset class="d-flex flex-wrap gap-1" :class="customClass" :disabled="disabled">
        <slot name="default">
            <ideo-form-checkbox v-for="(option, i) in options" :key="i" :value="option[valueField]" :disabled="isDisabled(option)" :checked="currentValue" @change="onChange">
                {{ option[textField] }}
            </ideo-form-checkbox>
        </slot>
    </fieldset>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from '@/helpers/Decorators';
import IdeoFormCheckbox from './IdeoFormCheckbox.vue';

@Options({
    name: 'ideo-form-checkbox-group',
    components: {
        'ideo-form-checkbox': IdeoFormCheckbox
    }
})
export default class IdeoFormCheckboxGroup extends Vue
{
    public currentValue: any[] = [];

    @Prop()
    public checked: any[];

    @Prop()
    public modelValue: any[];

    @Prop({ default: 'value' })
    public valueField: string;

    @Prop({ default: 'text' })
    public textField: string;

    @Prop({ default: (): any => [] })
    public options: Record<string, any>[];

    @Prop({ default: false })
    public stacked: boolean;

    @Prop({ default: false })
    public disabled: boolean;

    public get customClass(): Record<string, boolean>
    {
        return {
            'flex-row': this.stacked === false,
            'flex-column': this.stacked !== false
        };
    }

    public isDisabled(option: Record<string, any>): boolean
    {
        if (this.disabled == true)
            return true;

        if ('disabled' in option)
            return option.disabled;

        return false;
    }

    public onChange(value: any[]): void
    {
        const old = [...this.currentValue];

        this.currentValue = value;
        this.updateModel();
        this.change(value, old);
    }

    @Emit('change', { multipleEventArgs: true })
    public change(value: any[], old: any[]): [any[], any[]]
    {
        return [value, old];
    }

    @Emit('update:modelValue')
    public updateModel(): any[]
    {
        return this.currentValue;
    }

    @Watch('checked', { immediate: true })
    public onCheckedChanged(value: any[]): void
    {
        if (value !== undefined)
        {
            this.currentValue = value;
        }
    }

    @Watch('modelValue', { immediate: true })
    public onModelChanged(value: any[]): void
    {
        if (value !== undefined)
        {
            this.currentValue = value;
        }
    }
}
</script>
